<template>
    <div class="d-flex flex-column h-100">
        <div class="widget-title-wrapper d-flex justify-content-between align-items-end mb-2">
            <div class="widget-title ml-3 mt-2 flex-grow-1"><h5 class="mb-0">{{ data.title }}</h5></div>
            <div class="btn-toolbar " role="toolbar" aria-label="Action buttons">
                <div class="btn-group btn-group-sm" role="group">
                    <b-button variant="outline-secondary" @click="editConfiguration" v-if="data.widgetMode.mode=='edit' && data.supportsConfiguration">
                        <i class="fas fa-cog"></i>
                    </b-button>
                    <b-button variant="outline-danger" @click="removeWidget" v-if="data.widgetMode.mode=='edit'">
                        <i class="fas fa-times"></i>
                    </b-button>
                </div>
            </div>
        </div>

        <component ref="widget"
                   class="px-3 flex-grow-1 overflow-hidden"
                   :is="data.widgetComponent"
                   :title="data.title"
                   :dashboardWidgetConfigurationId="data.dashboardWidgetConfigurationId"
                   :configuration="data.configuration"
                   :widgetMode="data.widgetMode.mode"
                   :selected-time-range="data.selectedTimeRange"
                   @configurationChanged="configurationChanged">
        </component>

        <div class="ml-3 mt-1 mb-2" v-if="data.supportedTimeRanges">
            <b-button-group size="sm">
                <b-button variant="outline-secondary" @click="setTimeRange(timeRange.underlyingValue)" :pressed="timeRange.underlyingValue==data.selectedTimeRange" v-for="(timeRange,index) in data.supportedTimeRanges" :key="index">{{ $t('Vue.Dashboard.Shared.'+timeRange.stringValue) }}</b-button>
            </b-button-group>
        </div>
        <!--<div v-else class="smaller ml-1 mb-1 position-absolute text-black-50">
            Displaying values for the last 7 days.
        </div>-->
    </div>
</template>

<script>
    export default {
        name: 'WidgetWrapper',
        data() {
            return {
                data: {
                    panelId: null,
                    widgetComponent: null,
                    title: null,
                    dashboardWidgetConfigurationId: null,
                    supportsConfiguration: false,
                    supportedTimeRanges: null,
                    selectedTimeRange: null,
                    configuration: null,
                    widgetMode: null,
                    onRemoveWidget: null,
                    onConfigurationChanged: null,
                }
            }
        },
        methods: {
            setTimeRange: function (selectedTimeRange) {
                //this.data.selectedTimeRange = selectedTimeRange.toString();
                this.data.selectedTimeRange = selectedTimeRange;
            },
            removeWidget: function () {
                this.data.onRemoveWidget(this.data.panelId);
            },
            editConfiguration: function () {
                this.$refs.widget.editConfiguration();
            },
            configurationChanged: function (title, configuration) {

                this.data.title = title;
                this.data.configuration = configuration;
                this.data.onConfigurationChanged(this.data.panelId, this.data.title, this.data.configuration);
            }
        }       
    }
</script>

